import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V16C22 16.5523 21.5523 17 21 17H18V19C18 19.3788 17.786 19.725 17.4472 19.8944C17.1084 20.0638 16.703 20.0273 16.4 19.8L12.6667 17H3C2.44772 17 2 16.5523 2 16V5ZM4 6V15H13C13.2164 15 13.4269 15.0702 13.6 15.2L16 17V16C16 15.4477 16.4477 15 17 15H20V6H4Z",
		fill: "currentColor"
	})
});
export default SvgComment;
